import React from "react"

import RichText from "./richText"
import Buttons from "./buttons"

import GeniusPattern from "../../assets/svg/genius-pattern.svg"
import GeniusLogo from "../../assets/images/genius-logo.png"

import styles from "./geniusSection.module.scss"

const GeniusSection = ({ title, image, text, cta }) => (
  <section className="grid" id="genius">
    <div className={`gridItem large-3 ${styles.content}`}>
      <img src={GeniusLogo} alt="" />
      {title && <h2 className={styles.title}>{title}</h2>}
      {text && <RichText blocks={text} />}
      {cta && <Buttons buttons={cta?.button} />}
    </div>
    <div className={`gridItem large-8 large-offset-5 ${styles.imageWrapper}`}>
      <img src={image?.image?.asset.url} alt="" className={styles.phone} />
      <GeniusPattern className={styles.pattern} />
    </div>
  </section>
)

export default GeniusSection
